import { useMemo } from "react";
import { FilterableCheckboxGroupDropdown, type CheckboxGroup } from "@/components/FilterableCheckboxGroupDropdown";
import { ChevronDown, ShieldCheck } from "lucide-react";
import { ROLE_OPTIONS } from "@/pages/Dashboard/Backoffice/Users/AssignOrganizations/constants";

interface RolesFilterProps {
	selected: string[];
	onChange: (values: string[]) => void;
}

export const RolesFilter = ({ selected, onChange }: RolesFilterProps) => {
	const groups: CheckboxGroup[] = useMemo(
		() => [
			{
				name: "Roles",
				items: ROLE_OPTIONS.map(role => ({
					id: role.value,
					name: role.label,
					checked: selected.includes(role.value),
				})),
			},
		],
		[selected],
	);

	return (
		<FilterableCheckboxGroupDropdown
			groups={groups}
			onCheckedChange={(id, checked) => {
				const next = checked
					? Array.from(new Set([...selected, id]))
					: selected.filter(roleName => roleName !== id);
				onChange(next);
			}}
			onToggleAll={checked => {
				onChange(checked ? ROLE_OPTIONS.map(role => role.value) : []);
			}}
			buttonVariant="outline"
			buttonLabel="Roles"
			buttonClassName="flex items-center gap-2"
			renderItem={item => (
				<div className="flex items-center gap-2">
					<ShieldCheck className="h-4 w-4 text-blue-400" />
					{item.name}
				</div>
			)}
			buttonContent={
				<span className="flex items-center gap-2">
					{selected.length > 0 ? (
						<span className="text-[11px] text-muted-foreground">({selected.length} selected)</span>
					) : (
						<span>All</span>
					)}
					<ChevronDown className="ml-2 h-4 w-4 opacity-50" />
				</span>
			}
			contentAlign="end"
			searchPlaceholder="Search roles..."
		/>
	);
};
